// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes transparencyAnimation-0da3dead {\n0% {\n    opacity: 1;\n}\n50% {\n    opacity: 0.4;\n}\n100% {\n    opacity: 1;\n}\n}\n@keyframes transparencyAnimation-0da3dead {\n0% {\n    opacity: 1;\n}\n50% {\n    opacity: 0.4;\n}\n100% {\n    opacity: 1;\n}\n}\n.animate-transparency[data-v-0da3dead] {\n  -webkit-animation: transparencyAnimation-0da3dead 2s infinite;\n          animation: transparencyAnimation-0da3dead 2s infinite;\n}", ""]);
// Exports
module.exports = exports;
